export default __webpack_public_path__ + "898bf6c9a6848fd8a51ef5a92c3b2343.png";